const alert = () => {
  const alert = document.querySelector(".alert");
  if (!alert) return;

  const close = alert.querySelector(".alert-close");
  close.addEventListener("click", (e) => {
    alert.classList.add("is-hidden");
  });
};

export default alert;
